import {
  CfMediaQueriesConfigWrapper,
  StepWrapper,
  WrapContent,
} from "types/generic/types";

interface CfColSizeDictionary {
  [key: string]: StepWrapper;
}

const CF_WRAPCONTENT_DICTIONARY: CfColSizeDictionary = {
  sm: "sm",
  md: "md",
  lg: "lg",
  fluid: "fluid",
};

export const convertCfWrapContentProps = (
  cfProp: CfMediaQueriesConfigWrapper | undefined | null,
): WrapContent | undefined => {
  if (!cfProp) return undefined;
  return {
    xsWrapContent: cfProp.default
      ? CF_WRAPCONTENT_DICTIONARY[cfProp.default]
      : CF_WRAPCONTENT_DICTIONARY.fluid,
    mdWrapContent: cfProp.md ? CF_WRAPCONTENT_DICTIONARY[cfProp.md] : undefined,
    lgWrapContent: cfProp.lg ? CF_WRAPCONTENT_DICTIONARY[cfProp.lg] : undefined,
    xlWrapContent: cfProp.xl ? CF_WRAPCONTENT_DICTIONARY[cfProp.xl] : undefined,
  };
};
